import React from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Badge,
} from "reactstrap";

const ProfileCard = ({ userData }) => {
  return (
    <Col md="6">
      <Card>
        <CardHeader className="pb-0">
          <h5 className="d-flex align-items-center gap-2">
            User Profile
            {userData?.userType && (
              <Badge
                color={
                  userData.userType === "ADMIN" ? "primary" : "info"
                }
                pill
              >
                {userData.userType}
              </Badge>
            )}
          </h5>
        </CardHeader>
        <CardBody>
          <Form>
            <FormGroup>
              <Label htmlFor="username">Username</Label>
              <Input
                id="username"
                type="text"
                value={userData?.username || ""}
                disabled
                placeholder="Enter username"
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={userData?.email || ""}
                disabled
                placeholder="Enter email"
              />
            </FormGroup>
            <FormGroup>
              <Label>Partner UUID</Label>
              <Input
                type="text"
                value={userData?.partnerUuid || "N/A"}
                disabled
              />
            </FormGroup>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ProfileCard;
